import React, { Component } from 'react';


import Header from '../components/header/Header';
import Banner from '../components/banner/Banner';
import Auth from '../components/auth/Auth';
import Footer from '../components/footer/Footer';
import Addresses from '../components/addresses/Addresses';
import Checkout from '../components/checkout/Checkout'
import landingService from '../services/landing.service'
import couponService from '../services/coupon.service'
import userService from '../services/user.service'

declare var $;

class Recipe extends Component {

  constructor(props) {
      super(props);
      this.state = {
        dataCoupon: [],
        loading: true,
        logued: false,
        addressSelected: false,
        selectedAddress: [],
        error: '',
        couponData: [],
        userData: []
      };
      this.logout = this.logout.bind(this)
      this.stepBack = this.stepBack.bind(this)
      this.getUserData = this.getUserData.bind(this)
    }

  async componentWillMount() {
      let dataCoupon = await landingService.getLandingData(this.props.match.params.token)
        this.setState({ dataCoupon, loading: false})
        if(localStorage.getItem('accessToken')) {
          this.getUserData()
        }

  }

  handleAuth(e) {
    this.getUserData()
  }

async handleSelectedAddress(address) {
  $('.continue').button('loading');
     this.setState({
       selectedAddress: address,
       error: ''
    })
    let coupon = {
     coupon: {
       code: "LASONCES",// this.state.dataCoupon.coupon_code,
       lng: address.lng,
       lat: address.lat,
       purchase_type: "now",
       token: localStorage.getItem('accessToken')
     }
   }
     let response = await couponService.redeemCoupon(coupon)
     if(!response.error) {
       this.setState({
         couponData: response,
         addressSelected: true
       })
     } else {
       this.setState({
         error: response.error.message
       })
      $('.continue').button('reset');
     }
  }

  async getUserData() {
    let response = await userService.getUserData()
    this.setState({
      userData: response,
      logued: true
    })
    $('.fb').button('reset');
    $('.login').button('reset');
  }

  logout() {
    this.setState({
      logued: false,
      addressSelected: false
    })
    localStorage.removeItem('accessToken')
  }

  stepBack() {
    this.setState({
      addressSelected: false
    })
  }

  render() {
    return (
        <div >
        <Header></Header>
        <div id="content_wrapper">
          <Banner dataCoupon={this.state.dataCoupon} callto='Compra tus ingredientes!'></Banner>
          { !this.state.logued  && <Auth logued={this.handleAuth.bind(this)}></Auth> }
          { (this.state.logued && !this.state.addressSelected)   && <Addresses  userData={this.state.userData} error={this.state.error} setSelectedAddress={this.handleSelectedAddress.bind(this)}></Addresses> }
          { this.state.addressSelected  && <Checkout selectedAddress={this.state.selectedAddress} couponData={this.state.couponData}></Checkout> }
            <div className="text-center actions">
          { this.state.logued &&
             <p>
              { this.state.addressSelected &&
                <a className="logout" onClick={this.stepBack}>Atrás  | </a>
              }
               <a  className="logout" onClick={this.logout}> Salir </a></p>
          }
            </div>
          <Footer></Footer>
        </div>
        </div>
    );
  }
}




export default Recipe;



// WEBPACK FOOTER //
// ./src/modules/Recipe.js